import { inject } from "mobx-react";
import React from "react";
import { Route, RouteComponentProps, Switch, useHistory } from "react-router";
import {
  CreateView,
  IndexView,
  ShowView,
  withBreadCrumbs
} from "lego-gui-lib/lib";
import i18next from "i18next";
import { SanMatchingSchema } from "./schema";
import { observer } from "mobx-react-lite";

export const SanMatchings = {
  url: "/sanMatchings",
  handler: (props: RouteComponentProps<any>) => {
    const baseUrl = props.match.url;
    const title = i18next.t("hns:sanMatching:domain_plural");
    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <>
        <Switch>
          <Route exact={true} path={baseUrl} component={Index} />
          <Route path={baseUrl + "/create/:id"} component={Create} />
          <Route path={baseUrl + "/create"} component={Create} />
          <Route path={baseUrl + "/:id"} component={Show} />
        </Switch>
      </>
    );
  }
};

const injectDataSource = (comp: any) =>
  inject("sanMatching", "i18n")(observer(comp));

export const Index = injectDataSource(({ sanMatching, i18n, ...rest }: any) => {
  const title = i18n.t("hns:sanMatching:domain", { count: 2 });
  return (
    <IndexView
      dataSource={sanMatching.listDataSource}
      {...rest}
      title={title}
      toolbarButtons={{ delete: false, export: true }}
      rowButtons={{ edit: true, delete: true, copy: true, export: true }}
      columns={SanMatchingSchema}
    />
  );
});

export const Create = injectDataSource(
  ({ sanMatching, i18n, match, ...rest }: any) => {
    const title = i18n.t("common:create", { domain: "hns:sanMatching:domain" });
    const history = useHistory();
    return withBreadCrumbs(
      { to: match.url + "/edit", children: title },
      <CreateView
        dataSource={sanMatching.oneDataSource}
        {...rest}
        title={title}
        fields={SanMatchingSchema}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);

export const Show = injectDataSource(({ sanMatching, i18n, match }: any) => {
  const title = i18n.t("common:edit", { domain: "hns:sanMatching:domain" });
  const history = useHistory();
  return withBreadCrumbs(
    { to: match.url + "/edit", children: title },
    <ShowView
      dataSource={sanMatching.oneDataSource}
      title={title}
      fields={SanMatchingSchema}
      id={match.params}
      goBack={() => history.goBack()}
    />
  );
});
